import { useState } from 'react';

import { Field, useFormikContext } from 'formik';
import { DeleteDialogUI, FileTabUI, FormErrorUI, FormLabelUI, InputUI, TabsUI } from '../Interface';
import ExcelImportTab from '../Interface/ExcelImportTab';
import EmployeeAttendanceLine from './EmployeeAttendanceLine';
import { EmployeeAttendanceMode } from '../../config/employeeAttendance';
import { EmployeeAttendanceSimpleMode } from '../../utils/employeeAttendance';
import EmployeeAttendanceMyReportsTable from './EmployeeAttendanceMyReportsTable';
import useParam from '../../context/ParamContext';

const DescriptionPanel = ({ disabled }) => {
  const { errors, values } = useFormikContext();

  return (
    <div>
      <div className="col-span-full relative">
        <div className="mt-2">
          <Field
            type="text"
            name="description"
            as={InputUI}
            className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
            fullWidth
            label={<FormLabelUI text="Leírás" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.description} />}
            disabled={disabled}
            InputLabelProps={{ shrink: values.description !== '' }}
            multiline
            rows={10}
          />
        </div>
      </div>
    </div>
  );
};

const EmployeeAttendanceTabs = (props) => {
  const { values, setFieldValue } = useFormikContext();
  const { params } = useParam();
  const { mode, disabled, handleUploadFile } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    setFieldValue(
      'employeeAttendanceAttachment',
      (values.employeeAttendanceAttachment || []).filter(
        (employeeAttendanceAttachment) => employeeAttendanceAttachment.id !== fileToDelete.id
      )
    );

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const tabs = [
    {
      id: 0,
      name: 'Dolgozók',
      content: <EmployeeAttendanceLine {...props} />,
    },
    {
      id: 1,
      name: 'Megjegyzés',
      content: <DescriptionPanel {...props} />,
    },
    {
      id: 2,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={values?.employeeAttendanceAttachment ?? []}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          disabled={disabled}
          handleUpload={handleUploadFile}
        />
      ),
    },
    ...(mode === EmployeeAttendanceMode.MAIN
      ? [
          {
            id: 3,
            name: 'Adat import',
            content: <ExcelImportTab {...props} />,
          },
        ]
      : []),
    ...(EmployeeAttendanceSimpleMode(mode) && params.SHOW_EMPLOYEE_ATTENDANCE_MYREPORT_TAB === 'Y'
      ? [
          {
            id: 4,
            name: 'Lejelentéseim',
            content: <EmployeeAttendanceMyReportsTable {...props} />,
          },
        ]
      : []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4">
      <div className="md:px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};

export default EmployeeAttendanceTabs;
